import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchSuggestBoxSizes = createAction(ACTION.FETCH_SUGGEST_BOX_SIZES.REQUEST);
export const getSuggestsByVolume = createAction(ACTION.GET_SUGGESTS_BY_VOLUME.REQUEST);
export const clearSuggestBoxSizes = createAction(ACTION.CLEAR_SUGGEST_BOX_SIZES);
export const clearSuggestByVolumeBoxSizes = createAction(ACTION.CLEAR_SUGGEST_BY_VOLUME_BOX_SIZES);
